import axios from "axios";

// ✅ Use same environment key everywhere
const API_BASE = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE,
});

// ✅ Attach token automatically
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// --- 📦 Admin Order APIs ---

// ✅ List all orders with filters, pagination, etc.
export const listOrders = (params = {}) =>
  api.get("/admin/orders", { params }).then((r) => r.data);

// ✅ Get single order details
export const getOrder = (id) =>
  api.get(`/admin/orders/${id}`).then((r) => r.data);

// ✅ Edit limited fields (PATCH)
export const patchOrder = (id, payload) =>
  api.patch(`/admin/orders/${id}`, payload).then((r) => r.data);

// ✅ Cancel order
export const cancelOrder = (id) =>
  api.post(`/admin/orders/${id}/cancel`).then((r) => r.data);

// ✅ Mark order as shipped
export const shipOrder = (id) =>
  api.post(`/admin/orders/${id}/ship`).then((r) => r.data);

// ✅ Mark order as delivered
export const deliverOrder = (id) =>
  api.post(`/admin/orders/${id}/deliver`).then((r) => r.data);

// ✅ Export orders as CSV
export const exportCsv = (params) =>
  api.get("/admin/orders/export/csv/all", { params, responseType: "blob" }).then(r => r.data);

// ✅ Full PDF invoice URL
export const invoicePdfUrlAdmin = (id) =>
  `${API_BASE}/admin/orders/${id}/invoice/invoice.pdf`;
